import React, { useEffect, useState, useRef }  from 'react';
import { Widget } from '../../rest/views/Dashboard/Widget';
import Announcement from '../../rest/views/Dashboard/Announcement';
import ActionTaskWidget from 'containers/CoordinatorDashboardPage/components/MyActionTaskWidget';
import TaskListWidget from './components/TaskListWidget';
import BacklogTaskWidget from './components/BacklogTaskWidget';
import BookingRequestsWidget from './components/BookingRequestsWidget';
import MyBookingsWidget from './components/MyBookingsWidget';
import ProfilesWidget from './components/ProfilesWidget';
import QualityCheckWidget from './components/QualityCheckWidget';
import ShortcutsWidget from './components/ShortcutsWidget';
import NewsWidget from './components/NewsWidget';

const COLUMN_INDEXES = [1, 2, 3];

const SupplierDashboardPage = () => {
  const mounted = useRef(false);

  const [widgets, setWidgets] = useState([]);

  useEffect(() => {
    mounted.current = true;
    document.title = 'Dashboard';
    fetchWidgets();
    return () => {
      mounted.current = false;
    };
  }, []);

  const fetchWidgets = () => {
    setWidgets([]);
    fetch('/rest/v1/widget')
    .then((response) => response.json())
    .then((data) => {
      if (mounted.current) {
        setWidgets(data);
      }
    });
  };

  const widgetsByColumnId = (columnId) => {
    return widgets.filter(widget => widget.columnId == columnId);
  }

  return (
    <div className="mainDashboard flex flex-col w-full h-full antialiased text-sm">
      <Announcement />
      <div className="grow">
        {COLUMN_INDEXES.map((index) => (
          <ul key={index} className="w-full md:w-1/3 float-left clear-none list-none min-h-full">
            { widgetsByColumnId(index).map((widget) => {
              if (
                widget.widgetId == 'Open_Jobs' ||
                widget.widgetId == 'New_Jobs'
              ) {
                return <TaskListWidget key={widget.widgetId} widget={widget} />
              }

              if (widget.widgetId == 'Backlog') {
                return <BacklogTaskWidget key={widget.widgetId} widget={widget} /> 
              }

              if (widget.widgetId == 'Quality_Check') {
                return <QualityCheckWidget key={widget.widgetId} widget={widget} />
              }

              if (widget.widgetId == 'Action_Tasks') {
                // Shared with the coordinator dashboard, whose grid supplies its
                // own spacing - so this widget renders a bare <div>. Wrap it to
                // match the <li className="... m-4"> the other supplier widgets use.
                return (
                  <li key={widget.widgetId} className="m-4 list-none">
                    <ActionTaskWidget widget={widget} />
                  </li>
                )
              }

              if (widget.widgetId == 'Booking_Requests') {
                return <BookingRequestsWidget key={widget.widgetId} widget={widget} />
              }

              if (widget.widgetId == 'My_Bookings') {
                return <MyBookingsWidget key={widget.widgetId} widget={widget} />
              }

              if (widget.widgetId == 'Shortcuts') {
                return <ShortcutsWidget key={widget.widgetId} widget={widget} />
              }

              if (widget.widgetId == 'News') {
                return <NewsWidget key={widget.widgetId} widget={widget} />
              }

              if (widget.widgetId == 'Profiles') {
                return <ProfilesWidget key={widget.widgetId} widget={widget} />
              }

              return <Widget key={widget.widgetId} {...widget} />
            }) }
          </ul>
        ))}
      </div>
    </div>
  );
}

export default SupplierDashboardPage;
